module.exports = __webpack_public_path__ + "static/media/termo_responsabilidade_financeira.637da69f.pdf";